<template>
	<div class="wrap">
		<div class="header">智能GPRS电表</div>
		<div class="item item-one" @click="skip('/everyday')">
			<img class="item-img" src="../../assets/imgs/dbapp_rcyw.png" alt />
			<div class="item-text" style=" margin-left: 0.25rem;">
				<p class="item-text-p1">日常业务</p>
				<!-- <p class="item-text-p2">业务的文案XXXXX</p> -->
			</div>
		</div>
		<div class="item" @click="skip('/usingRecord')">
			<img class="item-img" src="../../assets/imgs/dbapp_xxdr.png" alt style=" width:0.56rem;height: 0.62rem;" />
			<div class="item-text" style=" margin-left: 0.3rem;">
				<p class="item-text-p1">电表开户</p>
				<!-- <p class="item-text-p2">业务的文案XXXXX</p> -->
			</div>
		</div>
		<div class="item" @click="skip('/selectedNum')">
			<img class="item-img" src="../../assets/imgs/dbapp_sdcxx.png" alt style=" width:0.47rem;height: 0.61rem;" />
			<div class="item-text" style=" margin-left: 0.38rem;">
				<p class="item-text-p1">售电记录</p>
				<!-- <p class="item-text-p2">业务的文案XXXXX</p> -->
			</div>
		</div>
		<div class="item" @click="skip('/bindingPhone')">
			<img class="item-img" src="../../assets/imgs/dbapp_yhcx.png" alt style=" width:0.47rem;height: 0.62rem;" />
			<div class="item-text" style=" margin-left: 0.38rem;">
				<p class="item-text-p1">状态查询</p>
				<!-- <p class="item-text-p2">业务的文案XXXXX</p> -->
			</div>
		</div>

		<div v-if="showOpenWeapp">
			<wx-open-launch-weapp id="launch-btn" appid="wx048535d911ffb688" :path="path">
				<script type="text/wxtag-template">
					<style>
					.item{
						width: 330px;background-color: #fff;border-radius: 12px;
						display: flex;
						align-items: center;height: 80px;margin-top: 30px;
					}
					.item-img {
     width:50px;height: 60px;margin-left: 35px;
    }
	.item-text-p1 {
	  font-size: 18px;color: #5fc6d2;
	}
    .item-text {
      margin-left:45px;
      }
	  </style>
	  <div class="item">
	    <img
	      class="item-img"
	      src="https://aliyunoss.hntgov.net/h5/dbapp_yhcx.png"
	      alt
	    />
	    <div class="item-text">
	      <p class="item-text-p1">蓝牙小程序</p>
	      <!-- <p class="item-text-p2">业务的文案XXXXX</p> -->
	    </div>
	  </div>
	</script>
			</wx-open-launch-weapp>
		</div>


	</div>
</template>

<script>
	import HeaderTop from "../../components/HeaderTop.vue";
	import jweixin from 'weixin-js-sdk';
	import {
		getWxConfig,
	} from "../../api";
	export default {
		name: "GetCommission",
		data() {
			return {
				path: '',
				showOpenWeapp: false,
			};
		},
		components: {
			HeaderTop
		},
		methods: {
			skip(url) {
				this.$router.push({
					path: url
				});
			},
			init(info) {
				console.log(info);
				jweixin.config({
					debug: false,
					appId: info.appId, // 找后端
					timestamp: info.timestamp, // 找后端
					nonceStr: info.nonceStr, // 找后端
					signature: info.signature, // 找后端
					jsApiList: ['checkJsApi',
						'openLocation',
						'getLocation',
						'closeWindow',
						'scanQRCode',
						'chooseWXPay',
						'chooseImage',
						'uploadImage',
						'previewImage',
						'getLocalImgData'
					],
					openTagList: ['wx-open-launch-weapp'] // 跳转必要的参数，需要使用的开放标签列表，例如['wx-open-launch-app']
				});
				// 监听结果
				jweixin.error((err) => {
					console.log('微信 JSSDK 初始化失败', err)
				});
				jweixin.ready((res) => {
					this.showOpenWeapp = true
					console.log('微信 JSSDK 初始化成功', res)
					// console.log('微信 JSSDK 初始化成功', res)
					// this.accredit();
				})

				//初始化微信jdk

			},
		},
		mounted() {
			this.path = 'pages/index/equipmentgl?userId=' + sessionStorage.getItem("userID")

			if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
				window.entryUrl = location.href.split('#')[0]
			}
			let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
			// 进行签名的时候  Android 不用使用之前的链接， ios 需要
			let signLink = isiOS ? window.entryUrl : location.href.split('#')[0];
			var uri = encodeURIComponent(signLink); //获取当前url然后传递给后台获取授权和签名信息
			getWxConfig(uri).then(res => {
				if (res.status == 1) {
					this.init(res.data);
				} else if (res.status == 0) {
					Toast.fail(res.msg);
				}
			})
		}
	};
</script>

<style scoped lang="less">
	.wrap {
		width: 100%;
		height: 100%;
		background: url("../../assets/imgs/backgound.png") center center no-repeat;
		display: flex;
		flex-direction: column;
		align-items: center;

		.header {
			width: 100%;
			height: 0.45rem;
			font-size: 0.15rem;
			line-height: 0.45rem;
			display: flex;
			justify-content: center;
			color: white;
			// position: fixed;
			position: absolute;
			top: 0;
			right: 0;
			z-index: 50;
			box-sizing: border-box;
			// color: #7adbbf;
			background-color: rgb(122, 219, 191);
		}

		.item {
			width: 330px;background-color: #fff;border-radius: 12px;
			display: flex;
			align-items: center;height: 120px;margin-top: 30px;

			.item-img {
				 width:50px;height: 60px;margin-left: 35px;
			}

			.item-text {
				   margin-left:45px;

				.item-text-p1 {
					font-size: 18px;color: #5fc6d2;
				}

				.item-text-p2 {
					font-size: 0.155rem;
					color: #5fc6d2;
					margin-top: 0.25rem;
				}
			}
		}

		.item-one {
			margin-top: 0.8rem;
		}
	}
</style>